module.exports = __webpack_public_path__ + "img/Drop Down Menu - Blue - Selected.5ea653bb.png";